const $ = jQuery;
const Woocommerce = {
  init: function () {
    $(".variation-radios input").on("change", function (element) {
      // $(".variation-radios input:checked").each(function (index, element) {
      const $el = $(this);
      const thisName = $el.attr("name");
      const thisVal = $el.attr("value");
      let parent = $el.closest(".variations_form");
      if ($(document.body).hasClass("single")) {
        parent = $(".variations_form");
        console.log(parent);
      }
      parent
        .find('select[name="' + thisName + '"]')
        .val(thisVal)
        .trigger("change");
      // });
    });
    $(document).on("woocommerce_update_variation_values", function () {
      $(".variation-radios input").each(function (index, element) {
        var $el = $(element);
        var thisName = $el.attr("name");
        var thisVal = $el.attr("value");
        $el.removeAttr("disabled");
        if (
          $(
            'select[name="' + thisName + '"] option[value="' + thisVal + '"]'
          ).is(":disabled")
        ) {
          $el.prop("disabled", true);
        }
      });
    });

    const observer = new MutationObserver(() => {
      let images = $(".flex-control-nav.flex-control-thumbs img");

      if (images.length > 0) {
        images.each(function () {
          this.removeAttribute("sizes");

          this.style.width = "auto";
          this.style.height = "auto";
        });

        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
};
export default Woocommerce;
